import {
  LayoutGrid,
  BookOpen,
  Building2,
  MessagesSquare,
  Shield,
  Star,
} from 'lucide-react';

const Sitemap = () => {
  const sitemapGroups = [
    {
      icon: BookOpen,
      title: 'サービス',
      links: [
        { name: 'サービス一覧', path: '/#services' },
        { name: '料金の目安', path: '/#pricing' },
      ],
    },
    {
      icon: Star,
      title: '選ばれる理由',
      links: [
        { name: '従来の開発会社との違い', path: '/#why' },
        { name: '開発実績（動画）', path: '/#demo' },
        { name: 'AI開発メソッド', path: '/method' },
      ],
    },
    {
      icon: Building2,
      title: '会社情報',
      links: [
        { name: '会社概要', path: '/company/about' },
        { name: 'ニュース', path: '/company/news' },
        { name: '採用情報', path: '/careers' },
        { name: '応募フォーム', path: '/careers/apply' },
      ],
    },
    {
      icon: MessagesSquare,
      title: 'お問い合わせ',
      links: [
        { name: '無料相談フォーム', path: '/#contact' },
      ],
    },
    {
      icon: Shield,
      title: 'コンプライアンス',
      links: [
        { name: 'プライバシーポリシー', path: '/privacy' },
        { name: '情報セキュリティ', path: '/security' },
        { name: '特定商取引法', path: '/specified-commercial-transactions' },
        { name: 'サイトマップ', path: '/sitemap' },
      ],
    },
  ];

  return (
    <div className="min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden bg-[#1B2A4A]">
        <div className="absolute inset-0 bg-[#4A6FA5]/10" />
        <div className="relative mx-auto max-w-6xl px-5 lg:px-6">
          <div className="flex justify-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/40 bg-[#B8860B]/10 px-4 py-1.5 mb-8">
              <LayoutGrid className="w-4 h-4 text-[#B8860B]" />
              <span className="text-sm font-semibold text-[#B8860B]">Site Map</span>
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-[3.3rem] font-bold text-center text-[#F5F3EF] leading-tight">
            サイトマップ
          </h1>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-[#F5F3EF]">
        <div className="mx-auto max-w-6xl px-5 lg:px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sitemapGroups.map((group, index) => {
              const Icon = group.icon;
              return (
                <div
                  key={index}
                  className="rounded-2xl border border-[#E8E6E1] bg-white p-8 shadow-sm"
                >
                  <div className="w-14 h-14 rounded-xl bg-[#1B2A4A]/10 flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-[#1B2A4A]" />
                  </div>

                  <h2 className="text-xl font-bold text-[#2D3748] mb-6">
                    {group.title}
                  </h2>

                  <ul className="space-y-4">
                    {group.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <a
                          href={link.path}
                          className="flex items-center gap-3 text-[#5A6577] hover:text-[#B8860B] transition-colors"
                        >
                          <div className="w-1.5 h-1.5 rounded-full bg-[#B8860B]" />
                          <span>{link.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;
